module.exports = __webpack_public_path__ + "img/empty-inbox.1d3739c5.svg";